import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core"
import { IProduct } from "graphql/queries/keyword.queries"
import { FilterContents } from "../../pipes/filter-contents.pipe"


@Component({
  selector: 'multipass-word-length-dropdown',
  templateUrl: 'multipass-word-length-dropdown.component.html'
})


export class MultipassWordLengthDropdownComponent implements OnInit {

  @Input() selectedContent: IProduct = null
  @Input() contents: IProduct[]
  @Output() selectedContentOutput = new EventEmitter<IProduct>()
  standardContents: IProduct[] = []
  customContents: IProduct[] = []
  standardFilteredContents: IProduct[] = []
  customFilteredContents: IProduct[] = []
  showEmptyResultsMessage = false
  showHr = true
  _mainInputCSSClass = ''

  contentSearch: string
  showPopCard = false

  constructor(private filterContentsPipe: FilterContents) {}


  ngOnInit() {
    this.contents.forEach(content => {
      content.standard ? this.standardContents.push(content) : this.customContents.push(content)
    })
    this.standardFilteredContents = this.standardContents
    this.customFilteredContents = this.customContents
    this.contentSearch = this.selectedContent?.name ?? ''
    this.setMainInputCSSClass(this.contentSearch)
  }

  filterContents(): void {
    this.standardFilteredContents = this.filterContentsPipe.transform(this.standardContents, this.contentSearch)
    this.customFilteredContents = this.filterContentsPipe.transform(this.customContents, this.contentSearch)
    this.showEmptyResultsMessage = this.standardFilteredContents.length === 0 && this.customFilteredContents.length === 0
    this.showHr = this.standardFilteredContents.length !== 0 && this.customFilteredContents.length !== 0
  }

  onFocus() {
    this.showPopCard = true
    this.setMainInputCSSClass(this.contentSearch)
  }

  setSelectedContent(content: IProduct): void {
    this.contentSearch = content.name
    this.selectedContentOutput.emit(content)
    this.showPopCard = false
    this.setMainInputCSSClass(this.contentSearch)
  }

  closeDialog(): void {
    let contentNames = this.contents.map(content => content.name)
    if(!contentNames.includes(this.contentSearch)) {
      this.contentSearch = ''
      this.standardFilteredContents = this.standardContents
      this.customFilteredContents = this.customContents
      this.selectedContentOutput.emit(null)
    }
    this.showPopCard = false
    this.setMainInputCSSClass(this.contentSearch)
  }

  setMainInputCSSClass(contentSearch: string) {
    if (contentSearch === '' && !this.showPopCard) {
      this._mainInputCSSClass = 'is-invalid'
    } else {
      this._mainInputCSSClass = ''
    }
  }

  get mainInputCSSClass(): string {
    return this._mainInputCSSClass
  }

}
